export const getAfterSalesSerialType = (searchParams) => {
  const serialType = searchParams.get("serialType");
  if (serialType === "1" || serialType === "2") {
    return serialType;
  }

  const legacyType = searchParams.get("type");
  if (legacyType === "1" || legacyType === "2") {
    return legacyType;
  }

  return "1";
};

export const getAfterSalesEncodedSerial = (searchParams) =>
  searchParams.get("sn") || "";

export const getAfterSalesApiSerial = (searchParams) => {
  const encodedSerial = getAfterSalesEncodedSerial(searchParams);
  if (!encodedSerial) {
    return "";
  }

  if (getAfterSalesSerialType(searchParams) === "2") {
    return encodedSerial;
  }

  try {
    return atob(encodedSerial);
  } catch (error) {
    return "";
  }
};

export const buildAfterSalesQuery = (searchParams, extraParams = {}) => {
  const params = new URLSearchParams();
  const encodedSerial = getAfterSalesEncodedSerial(searchParams);
  const serialType = getAfterSalesSerialType(searchParams);

  if (encodedSerial) {
    params.set("sn", encodedSerial);
  }

  if (serialType === "2") {
    params.set("serialType", "2");
  }

  Object.entries(extraParams).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      params.set(key, value);
    }
  });

  const query = params.toString();
  return query ? `?${query}` : "";
};

export const parseQrSerialPayload = (qrData) => {
  try {
    const url = new URL(qrData);
    const encodedSerial = url.searchParams.get("sn") || "";
    const serialType =
      url.searchParams.get("serialType") || url.searchParams.get("type") || "1";

    if (!encodedSerial) {
      return {
        apiSerial: "",
        serialType: "1",
      };
    }

    if (serialType === "2") {
      return {
        apiSerial: encodedSerial,
        serialType: "2",
      };
    }

    return {
      apiSerial: atob(encodedSerial),
      serialType: "1",
    };
  } catch (error) {
    return {
      apiSerial: "",
      serialType: "1",
    };
  }
};